import React from 'react';
import { CentroTabId } from '../types/centro.types';

interface CentroFormTabsProps {
    activeTab: CentroTabId;
    onTabChange: (tab: CentroTabId) => void;
}

const TABS: { id: CentroTabId; label: string; icon: string; btnId: string }[] = [
    { id: 'atencion', label: 'General y Fiscales', icon: 'far fa-building', btnId: 'centro-tab-btn-atencion' },
    { id: 'servicios', label: 'Cobertura', icon: 'far fa-tools', btnId: 'centro-tab-btn-servicios' },
    { id: 'expediente', label: 'Expediente Técnico', icon: 'fas fa-clipboard-list', btnId: 'centro-tab-btn-expediente' },
    { id: 'location', label: 'Ubicación', icon: 'far fa-map-marked-alt', btnId: 'centro-tab-btn-location' },
];

export const CentroFormTabs: React.FC<CentroFormTabsProps> = ({ activeTab, onTabChange }) => (
    <ul className="nav nav-tabs mb-4 flex-nowrap text-nowrap overflow-auto" style={{ paddingBottom: '1px' }}>
        {TABS.map((tab) => (
            <li className="nav-item" key={tab.id}>
                <button
                    type="button"
                    id={tab.btnId}
                    className={`nav-link fw-bold ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => onTabChange(tab.id)}
                >
                    <i className={`${tab.icon} me-1`} /> {tab.label}
                </button>
            </li>
        ))}
    </ul>
);
